export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5122.8de830d7.jpg";